import { IApplicationState } from '../types/redux';
import { ISeoLink } from '../types/newbuilding/seoLink';

export const seoLinksSelector = (state: IApplicationState): ISeoLink[] => {
  return state.newbuilding.seoLinks;
};
